import ngDialog from 'ng-dialog';
import 'angucomplete-alt';
import usefulDirectives from "../../helpers/usefulDirectives";
import regionData from './regionData';


/**
 * XLS parsed by - http://oss.sheetjs.com/js-xlsx/
 * XLS got from - https://www.czso.cz/csu/czso/klasifikace_uzemnich_statistickych_jednotek_-cz_nuts-_2011
 */
export default angular.module('regionDimensions', [
	ngDialog,
	'angucomplete-alt',
	usefulDirectives
])
	.service('regionDimensions', function() {
		this.dimensions = [];

		/**
		 * Set default storage and set values
		 */
		// let db = low('app/services/regionDimensions/regionDimensions.json');
		// db.defaults([]).value();

		// this.dimensions = db.getState();
		this.dimensions = regionData;

		this.getDimensions = () => {
			return angular.copy(this.dimensions);
		};

		this.setDimensions = (dimensions) => {
			this.dimensions = angular.copy(dimensions);
		};
	})
	.directive('regionSelector', function() {
		return {
			template: `
				<a class="btn btn-{{ctrl.btnClass}}" uib-tooltip="{{ctrl.tooltip}}" ng-click="ctrl.openSelector()"><i class="fa fa-comment"></i></a>`,
			restrict: 'E',
			scope: {},
			replace: true,
			bindToController: {
				selectTo: '=',
				btnClass: '<',
				tooltip: '<',
				onSelect: '<'
			},
			controller: function(ngDialog, $scope, $timeout) {
				if (angular.isUndefined(this.tooltip)) {
					this.tooltip = 'Vybrat z číselníku';
				}

				if (angular.isUndefined(this.btnClass)) {
					this.btnClass = 'warning';
				}

				/**
				 * Open modal for changing password
				 */
				this.openSelector = () => {
					ngDialog.open({
						template: 'services/regionDimensions/selector.tpl.html',
						controller: function($scope, regionDimensions) {
							this.regionDimensions = regionDimensions.getDimensions();

							this.select = () => {
								if (angular.isDefined(this.selected)) {
									$scope.closeThisDialog({value: this.selected.originalObject});
								} else {
									$scope.closeThisDialog(false);
								}
							};
						},
						controllerAs: 'ctrl',
						name: 'regionSelectorDialog'
					}).closePromise.then((response) => {
						if (angular.isDefined(response.value.value)) {
							this.selectTo = response.value.value.kod;

							if (angular.isFunction(this.onSelect)) {
								this.onSelect(response.value.value);
							}
						}
					});
				};

				/**
				 * Ugly, dirty OMFG solution, but this autocomplete does not support programmatic focus
				 */
				$scope.$on('ngDialog.opened', function(e, dialog) {
					if (dialog.name == 'regionSelectorDialog') {
						$timeout(() => {
							document.querySelector('#_value').focus();
						});
					}
				});
			},
			controllerAs: 'ctrl'
		};
	})
	.name;



// WEBPACK FOOTER //
// build/services/regionDimensions/regionDimensions.js